var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root,style:({ width: `${_vm.size}px` })},[_c('div',{class:_vm.$style.container},[(_vm.src)?_c('img',{class:_vm.$style.img,attrs:{"src":_vm.src,"alt":_vm.alt}}):_c('i',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }